module.exports = __webpack_public_path__ + "131740fbcd5b417ed757a588d2efe541.jpg";